import { useQuery, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { ILeadActionsResponse } from "../models/Lead";

export default function useLeadActions({ leadId } : { leadId: string }) {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const leadActions = useQuery({
    queryKey: ["leadActions", leadId],
    queryFn: () => get<ILeadActionsResponse>(`/leadaction/lead/${leadId}`),
    enabled: !!leadId,
  })

  return {
    leadActions
  };
}